import {
  AdvanceInvestmentFilter,
  IceRowType,
  InvestmentAdvanceSubtype,
} from "../helpers/constant";
export default {
  setInvestmentAdvanceType(payload, investmentdescription) {
    let userEnteredData = [];
    for (let i = 0; i < payload.length; i++) {
      let amount = this.defaultIntValue(payload[i].amount);
      let rowTypeId = this.getICERowType(
        payload[i].typeId,
        payload[i].subTypeId
      );
      if (rowTypeId == IceRowType.Investment_MarketDrop) {
        amount = -amount;
      }

      let row = this.addICERow(
        rowTypeId,
        payload[i],
        amount,
        investmentdescription
      );
      userEnteredData.push(row);
    }

    return userEnteredData;
  },
  defaultStringValue(value) {
    if (!value) {
      return "";
    } else {
      return value;
    }
  },

  defaultIntValue(value) {
    if (!value || value == "" || isNaN(value)) {
      return 0;
    } else {
      return value;
    }
  },
  addICERow(TypeId, GridRow, Amount, investmentdescription) {
    let row = {};
    row.Type = TypeId;
    row.Amount = Amount;
    row.END = this.defaultDateValue(GridRow.endDate);
    row.AccountNumber = "";
    row.EndType = this.defaultIntValue(GridRow.endDateType);
    row.Start = this.defaultDateValue(GridRow.startDate);
    row.StartType = this.defaultIntValue(GridRow.startDateType);
    row.Indexation = this.defaultIntValue(GridRow.index);
    row.Frequency = this.defaultIntValue(GridRow.frequency);
    row.EffectiveAsOn =
      TypeId == IceRowType.Investment_In_LS ||
      TypeId == IceRowType.Investment_In_Reg ||
      TypeId == IceRowType.Investment_Out_LS ||
      TypeId == IceRowType.Investment_Out_Reg
        ? 2
        : 0;
    row.Description = investmentdescription;
    return row;
  },
  defaultDateValue(element) {
    if (!element || element == "") {
      return "";
    } else {
      let isDateAppend = element.split("/");
      if (isDateAppend.length > 2) {
        return element;
      }
      return "01/" + element;
    }
  },
  getICERowType(typeId, subTypeId) {
    if (
      typeId == AdvanceInvestmentFilter.Return &&
      subTypeId == IceRowType.Investment_Growth_Rate
    ) {
      return IceRowType.Investment_Growth_Rate;
    } else if (
      typeId == AdvanceInvestmentFilter.Return &&
      subTypeId == IceRowType.Investment_Franking_Rate
    ) {
      return IceRowType.Investment_Franking_Rate;
    } else if (
      typeId == AdvanceInvestmentFilter.Return &&
      subTypeId == IceRowType.Investment_Income_Rate
    ) {
      return IceRowType.Investment_Income_Rate;
    } else if (
      typeId == AdvanceInvestmentFilter.Contribution &&
      subTypeId == InvestmentAdvanceSubtype.Contribution.Regular
    ) {
      return IceRowType.Investment_In_Reg;
    } else if (
      typeId == AdvanceInvestmentFilter.Contribution &&
      subTypeId == InvestmentAdvanceSubtype.Contribution.LumpSum
    ) {
      return IceRowType.Investment_In_LS;
    } else if (
      typeId == AdvanceInvestmentFilter.Withdrawal &&
      subTypeId == InvestmentAdvanceSubtype.Withdrawal.Regular
    ) {
      return IceRowType.Investment_Out_Reg;
    } else if (
      typeId == AdvanceInvestmentFilter.Withdrawal &&
      subTypeId == InvestmentAdvanceSubtype.Withdrawal.LumpSum
    ) {
      return IceRowType.Investment_Out_LS;
    } else if (
      typeId == AdvanceInvestmentFilter.Fee &&
      subTypeId == InvestmentAdvanceSubtype.Fee.Regular
    ) {
      return IceRowType.Investment_Out_Reg;
    } else if (
      typeId == AdvanceInvestmentFilter.Fee &&
      subTypeId == InvestmentAdvanceSubtype.Fee.LumpSum
    ) {
      return IceRowType.Investment_Out_LS;
    } else if (
      typeId == AdvanceInvestmentFilter.MarketCrash &&
      subTypeId == IceRowType.Investment_MarketDrop
    ) {
      return IceRowType.Investment_MarketDrop;
    } else if (
      typeId == AdvanceInvestmentFilter.MarketCrash &&
      subTypeId == IceRowType.Investment_MarketDropRecoveryPercent
    ) {
      return IceRowType.Investment_MarketDropRecoveryPercent;
    }
  },
};
